export default __webpack_public_path__ + "static/media/NZ_Shipping_Update_18092026.07a6718a.zip";